module.exports = __webpack_public_path__ + "static/media/greyAdd.5b5ed26b.svg";